import { Sidebar } from '@/components/Sidebar';
import { cn } from '@/lib/utils';

export const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <main className="ml-64 min-h-screen transition-all duration-300" data-testid="main-content">
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
